import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals'; 
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import App from './App';
import Home from './pages/Home';
import Report from './pages/Report';
import ReportGoals from './pages/ReportGoals';
import Sales from './pages/Sales';
import Event from './pages/Event';
import Institution from './pages/Institution';
import Invoice from './pages/Invoice';
import Analytics from './pages/Analytics';
import Shift from './pages/Shift';
import ShiftNew from './pages/ShiftNew';
import MyShift from './pages/MyShift';
import Prospects from './pages/Prospects';
import LoginForm from './pages/auth/login';
import Logout from './pages/auth/logout';
import Attendance from './pages/admin/Attendance';
import AdminInvoice from './pages/admin/AdminInvoice';
import AdminDailyReport from './pages/admin/DailyReport';
import ReportFieldConfig from './pages/admin/ReportFieldConfig';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminUserManagement from './pages/admin/UserManagement';
import NoticeManagement from './pages/admin/NoticeManagement';
import PushDeliveryLogs from './pages/admin/PushDeliveryLogs';
import ActivityNotificationManagement from './pages/admin/ActivityNotificationManagement';
import Notices from './pages/Notices';
import TestList from './pages/tests/TestList';
import TestQuestion from './pages/tests/TestQuestion';
import TestHistory from './pages/tests/TestHistory';
import TestThemeManagement from './pages/admin/TestThemeManagement';
import TestAnswerHistoryManagement from './pages/admin/TestAnswerHistoryManagement';
import MaterialManagement from './pages/admin/MaterialManagement';
import AdminShiftManagement from './pages/admin/ShiftManagement';
import Learning from './pages/Learning';
import ProtectedRoute from './components/ProtectedRoute';
import PermissionGuard from './components/PermissionGuard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ProtectedRoute>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/logout" element={<Logout />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/report" element={<Report />} />
            <Route path="/report-goals" element={<ReportGoals />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/event" element={<Event />} />
            <Route path="/institution" element={<Institution />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path='/analytics' element={<Analytics />} />
            <Route path="/shift" element={<Shift />} />
            <Route path="/shift-new" element={<ShiftNew />} />
            <Route path="/my-shift" element={<MyShift />} />
            <Route path="/prospects" element={<Prospects />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/tests" element={<TestList />} />
            <Route path="/tests/:themeId" element={<TestQuestion />} />
            <Route path="/tests/history" element={<TestHistory />} />
            <Route path="/admin/attendance" element={<PermissionGuard permissionKey="attendance_admin"><Attendance /></PermissionGuard>} />
            <Route path="/admin/invoice" element={<PermissionGuard permissionKey="invoice_admin"><AdminInvoice /></PermissionGuard>} />
            <Route path="/admin/daily-report" element={<PermissionGuard permissionKey="report_admin"><AdminDailyReport /></PermissionGuard>} />
            <Route path="/admin/report-field-config" element={<PermissionGuard permissionKey="report_admin"><ReportFieldConfig /></PermissionGuard>} />
            <Route path="/admin/analytics" element={<PermissionGuard permissionKey="analytics_admin"><AdminAnalytics /></PermissionGuard>} />
            <Route path="/admin/users" element={<PermissionGuard permissionKey="users_admin"><AdminUserManagement /></PermissionGuard>} />
            <Route path="/admin/notices" element={<PermissionGuard permissionKey="notices_admin"><NoticeManagement /></PermissionGuard>} />
            <Route path="/admin/push-logs" element={<PermissionGuard permissionKey="notices_admin"><PushDeliveryLogs /></PermissionGuard>} />
            <Route path="/admin/activity-notifications" element={<PermissionGuard permissionKey="notices_admin"><ActivityNotificationManagement /></PermissionGuard>} />
            <Route path="/admin/test-themes" element={<PermissionGuard permissionKey="tests_admin"><TestThemeManagement /></PermissionGuard>} />
            <Route path="/admin/tests-history" element={<PermissionGuard permissionKey="tests_admin"><TestAnswerHistoryManagement /></PermissionGuard>} />
            <Route path="/admin/materials" element={<PermissionGuard permissionKey="learning_admin"><MaterialManagement /></PermissionGuard>} />
            <Route path="/admin/shift-management" element={<PermissionGuard permissionKey="shift_admin"><AdminShiftManagement /></PermissionGuard>} />
            <Route path="/learning" element={<PermissionGuard permissionKey="learning_view"><Learning /></PermissionGuard>} />
            <Route path="*" element={<App />} />
          </Route>
        </Routes>
      </ProtectedRoute>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
